import type { GameRoomState } from "@presidents/game-engine";
import React from "react";
import styled from "styled-components";
import { createPlayerMap } from "../utils/create-player-map";
import { Cell, Name, Row, Table, TBody } from "./LeaderBoard";

export const Rank = styled.span`
  font-size: 11px;
  white-space: nowrap;
  padding: 2px 6px;
  &[data-rank="P"] {
    background-color: var(--success);
  }
  &[data-rank="VP"] {
    background-color: var(--successMuted);
  }
  &[data-rank="VA"] {
    background-color: var(--assholeMuted);
  }
  &[data-rank="A"] {
    background-color: var(--asshole);
  }
`;

type Props = {
  players: GameRoomState["players"];
  playerRanks: GameRoomState["playerRanks"];
};
const PlayerRanks: React.FC<Props> = ({ playerRanks, players }) => {
  const playersMap = createPlayerMap(players);
  return (
    <Table>
      <TBody>
        {playerRanks.map((id, i) => {
          return (
            <Row key={id}>
              <Cell>
                <Name>{playersMap[id]?.name}</Name>
              </Cell>
              <Cell align="right">
                {i === 0 && <Rank data-rank="P">President</Rank>}
                {i === playerRanks.length - 1 && (
                  <Rank data-rank="A">Asshole</Rank>
                )}
              </Cell>
            </Row>
          );
        })}
      </TBody>
    </Table>
  );
};

export default PlayerRanks;
